import React from 'react';

import { Flex } from '@chakra-ui/react';

import PeerAnswer from './components/PeerAnswer';
import PeerDetailsRow from './components/PeerDetailsRow';

// used to display peer feedback to only manager in review forms

const PeerFeedbackRenderer = ({
  employee,
  providerType,
  feedbackTextHtml = '',
  feedbackText = '',
  selectedAnswerOptions,
  question,
  peerType,
}) => (
  <Flex flexDir="column">
    <PeerDetailsRow employee={employee} providerType={providerType} peerType={peerType} />
    <PeerAnswer
      feedbackTextHtml={feedbackTextHtml}
      feedbackText={feedbackText}
      selectedAnswerOptions={selectedAnswerOptions}
      question={question}
    />
  </Flex>
);

export default PeerFeedbackRenderer;
